import * as Bixby from '$/core';

export abstract class UserClientService {
  public static baseUrl = Bixby.Constants.API_USERCONTROLLER;

  public static async forgotPassword(forgotCommand: Bixby.Models.ForgotPasswordRequest) {
    const route = Bixby.API.ServerRoute.forAction(
      UserClientService.baseUrl,
      Bixby.Constants.API_ACTION_USER_FORGOTPASSWORD
    );
    return await Bixby.API.patch(route, forgotCommand);
  }

  public static async resetPassword(resetCommand: Bixby.Models.ResetPasswordRequest) {
    const route = Bixby.API.ServerRoute.forAction(
      UserClientService.baseUrl,
      Bixby.Constants.API_ACTION_RESETPASSWORD
    );
    return await Bixby.API.patch<string>(route, resetCommand);
  }

  public static async userEmailConfirmation(verify: Bixby.Models.UserEmailConfirmationRequest) {
    const route = Bixby.API.ServerRoute.forAction(
      UserClientService.baseUrl,
      Bixby.Constants.API_ACTION_USER_USEREMAILCONFIRMATION
    );
    return await Bixby.API.patch(route, verify);
  }

  public static async verifyPasswordResetToken(verify: Bixby.Models.VerifyPasswordResetTokenRequest): Promise<boolean> {
    const route = Bixby.API.ServerRoute.forAction(
      UserClientService.baseUrl,
      Bixby.Constants.API_ACTION_USER_VERIFYPASSWORDRESETTOKEN
    );
    return await Bixby.API.patch(route, verify);
  }

  public static async verifyUserEmailConfirmationToken(
    verify: Bixby.Models.VerifyUserEmailConfirmationTokenRequest
  ): Promise<boolean> {
    const route = Bixby.API.ServerRoute.forAction(
      UserClientService.baseUrl,
      Bixby.Constants.API_ACTION_USER_VERIFYUSEREMAILCONFIRMATIONTOKEN
    );
    return await Bixby.API.patch(route, verify);
  }
}
